import { EpochRewardsSummaryApiResponseType, EpochRewardsSummaryType } from "@/types";
import { normaliseDeviceClassModels } from "@/utils/deviceClassSplit";

export const toFiniteNumber = (value: unknown): number | undefined => {
  return typeof value === "number" && Number.isFinite(value) ? value : undefined;
};

export const normaliseEpochRewardsSummary = (
  response: EpochRewardsSummaryApiResponseType
): EpochRewardsSummaryType => {
  const summary = response?.data?.summary;
  const rewardsByDeviceClass = response?.data?.rewards_by_device_class;

  return {
    totalDistributed: toFiniteNumber(summary?.total_coins_distributed),
    todayDistributed: toFiniteNumber(summary?.todays_coins_distributed),
    totalCompleted: toFiniteNumber(summary?.total_epochs_completed),
    totalSuppliersPaid: toFiniteNumber(summary?.total_unique_suppliers_paid),
    todaySuppliersPaid: toFiniteNumber(summary?.todays_unique_suppliers_paid),
    nextEpochStartMinutes: toFiniteNumber(summary?.next_epoch_start_minutes) ?? null,
    rewardsByDeviceClass: {
      totalIo: toFiniteNumber(rewardsByDeviceClass?.total_io),
      models: normaliseDeviceClassModels(rewardsByDeviceClass?.models)
    }
  };
};

export const formatNextEpochStartMinutes = (value: number | null | undefined) => {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return "--";
  }

  return `${Math.max(0, Math.round(value))} minutes`;
};
